<template>
  <section class="dvs-summary-card">
    <div class="dvs-section-head">
      <h1 class="dvs-summary-title">Revisar datos</h1>
    </div>

    <div class="dvs-summary-list">
      <div class="dvs-summary-row">
        <i class="bi bi-calendar3" aria-hidden="true"></i>
        <span>Fecha</span>
        <strong>{{ form.fecha ? formatFecha(form.fecha) : '00/00/0000' }}</strong>
      </div>

      <div class="dvs-summary-row">
        <i class="bi bi-person" aria-hidden="true"></i>
        <span>Operador</span>
        <strong>{{ form.operadorLabel || '—' }}</strong>
      </div>

      <div class="dvs-summary-row">
        <i class="bi bi-cpu" aria-hidden="true"></i>
        <span>Máquina / Producto</span>
        <strong>{{ maquinaProductoLabel }}</strong>
      </div>

      <div class="dvs-summary-row">
        <i class="bi bi-palette" aria-hidden="true"></i>
        <span>Color / Mezcla</span>
        <strong>{{ mezclaLabel }}</strong>
      </div>

      <div class="dvs-summary-row">
        <i class="bi bi-arrow-up-circle" aria-hidden="true"></i>
        <span>Vena (kg)</span>
        <strong>{{ form.venaKg !== '' && form.venaKg !== undefined ? formatKg(form.venaKg) : '000.00' }}</strong>
      </div>

      <div class="dvs-summary-row">
        <i class="bi bi-arrow-down-circle" aria-hidden="true"></i>
        <span>Scrap (kg)</span>
        <strong>{{ form.scrapKg !== '' && form.scrapKg !== undefined ? formatKg(form.scrapKg) : '000.00' }}</strong>
      </div>

      <div class="dvs-summary-row dvs-summary-row--long">
        <i class="bi bi-chat-left-text" aria-hidden="true"></i>
        <span>Observaciones</span>
        <strong>{{ form.comentarios || 'Sin observaciones' }}</strong>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
});

const maquinaProductoLabel = computed(() => {
  const maquina = props.form.maquinaLabel || '—'
  const producto = props.form.productoLabel || '—'

  return `${maquina} · ${producto}`
})

const mezclaLabel = computed(() => {
  const color = props.form.colorLabel || '—'
  const aditivo = props.form.aditivo ? 'Sí' : 'No'

  return `${color} · Aditivo: ${aditivo}`
})

function formatKg(val) {
  const n = parseFloat(val);
  return isNaN(n) ? '000.00' : n.toFixed(2);
}

function formatFecha(fecha) {
  if (!fecha) return '00/00/0000';
  const [y, m, d] = fecha.split('-');
  return `${d}/${m}/${y}`;
}
</script>
